import consultoriasRotas from './consultorias/ConsultoriasRotas'

export default {
    path: 'appsebrae',
    name: 'AppSebrae',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [consultoriasRotas]
}
